import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {textEllipsis} from '@travel-frontend/ui-components';

type Props = {
  isHighlighted?: boolean;
  isSelected?: boolean;
};
export const Name = styled.span<Props>(({theme, isHighlighted, isSelected}) => {
  let textStyle = theme.typography.labelMedium;
  if (isSelected) {
    textStyle = theme.typography.labelMediumBold;
  } else if (isHighlighted) {
    textStyle = theme.typography.labelMediumSemiBold;
  }

  return css`
    max-width: 70%;
    ${textEllipsis}
    ${textStyle}
  `;
});
